/**
 * @providesModule QCreateClass
 */

/**
 * 批量为对象添加属性
 * @type {function(*=, *=, *=): *}
 */
export const createClass = function () {
    function defineProperties(target, props) {
        for (let i = 0; i < props.length; i++) {
            const descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;

            if ("value" in descriptor) {
                descriptor.writable = true;
            }

            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }

    return function (Constructor, protoProps, staticProps) {
        if (protoProps) {
            defineProperties(Constructor.prototype, protoProps);
        }

        if (staticProps) {
            defineProperties(Constructor, staticProps);
        }

        return Constructor;
    };
}();
